import React from 'react';
import ServiceDetailTemplate from '../components/service/ServiceDetailTemplate';

function CreditoCarbono() {
    const data = {
        title: "Crédito de Carbono",
        // Seguindo a sequência: /assets/images/novos/1/4.png
        mainImage: "/assets/images/novos/1/4.png",
        description1: "Sustentabilidade transformada em ativo financeiro. Atuamos na estruturação de projetos que conectam preservação ao mercado global.",
        description2: "A GB Partner apoia desde a modelagem técnica e certificação até a monetização dos créditos gerados por áreas preservadas ou projetos sustentáveis.",
        cards: [
            // Mantendo o padrão de ícones absolutos: /assets/images/servicos/3/1.png
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Certificação Ambiental", 
                disc: "Validação de projetos conforme padrões internacionais." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Ativos Ambientais", 
                disc: "Transformação de áreas verdes em valor econômico real." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Selo Verde", 
                disc: "Obtenção de selos que atestam a responsabilidade ESG da empresa." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Monetização", 
                disc: "Conexão direta com compradores globais de crédito." 
            }
        ],
        processSteps: [
            { title: "Modelagem", disc: "Análise da área e viabilidade técnica do projeto." },
            { title: "Certificação", disc: "Registro e auditoria por órgãos ambientais competentes." },
            { title: "Venda", disc: "Colocação dos ativos no mercado para geração de receita." }
        ],
        benefitTitle: "Benefícios para Empresas",
        benefitDisc: "Posicionamento estratégico no mercado de sustentabilidade:",
        benefits: [
            "Nova fonte de receita sustentável",
            "Adequação completa aos pilares ESG",
            "Valorização institucional e de marca",
            "Acesso a novos incentivos legais e fiscais"
        ]
    };

    return <ServiceDetailTemplate {...data} />;
}

export default CreditoCarbono;